import { NoticeBoardDto } from './notice-board.dto';

export class NoticeBoardListDto extends NoticeBoardDto {
  adminName?: string;
}
